import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { DialogAttributeComponent } from "../../other/dialog-attribute/dialog-attribute.component";
import { Observable, Subscription, map, of } from "rxjs";
import { MxCell, MxGraph } from "../../../../@core/model/mxgraph";
import { CheckAttribute } from "../../../../@core/model/check-attribute";
import { NgSelectComponent } from "@ng-select/ng-select";
import {
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbToastrService,
  NbWindowRef,
} from "@nebular/theme";
import { DataService } from "../../../../@core/utils/data.service";
import { GraphHandlerService } from "../../../../@core/utils/graph.service";
import { IntentRecognition } from "../../../../@core/model/intent-recognition";
import { UntypedFormGroup } from "@angular/forms";
import {
  RxFormBuilder,
  RxwebValidators,
} from "@rxweb/reactive-form-validators";
import { noWhitespaceValidator } from "../../../../@core/utils/helpers";
import { SignalRService } from "../../../../@core/utils/signalR.service";
import { MultipleGrammarComponent } from "../../other/mutiple-grammar/multiple-grammar.component";
import { IntentRouting } from "../../../../@core/model/intent-routing";

@Component({
  selector: "intent-routing",
  templateUrl: "./intent-routing.component.html",
  styleUrls: ["./intent-routing.component.scss"],
})
export class IntentRoutingComponent implements OnInit, OnDestroy {
  @ViewChild("multipleGrammar", {
    static: true,
  })
  multipleGrammar: MultipleGrammarComponent;
  listCondition;
  cell: MxCell;
  graph: MxGraph;
  data: IntentRouting = new IntentRouting();
  @ViewChild("autoInput") input;
  @ViewChild(NgSelectComponent) selectComponents: NgSelectComponent;
  filteredOptions$: Observable<any[]> = of(this.dataService.ivrAttribute);
  cancelAction = false;
  attributes: any = this.dataService.ivrAttribute;
  mentionConfig = {
    items: this.attributes,
    triggerChar: "{",
    labelKey: "value",
    disableSort: true,
    mentionSelect: (item) => {
      return "{" + item.value + "}";
    },
  };
  grammarArray = [];
  formGroup: UntypedFormGroup;
  grammarStatusChangedSubscription: Subscription;
  errorMessage: string = "Intent is required.";
  constructor(
    private dialogService: NbDialogService,
    protected windowRef: NbWindowRef,
    public dataService: DataService,
    private graphService: GraphHandlerService,
    private formBuilder: RxFormBuilder,
    private toastrService: NbToastrService,
    private signalRService: SignalRService
  ) {
    this.createForm();
  }
  ngOnDestroy(): void {
    this.grammarStatusChangedSubscription.unsubscribe();
  }
  onChange(event) {
    const textArea = document.getElementById("input-text");
    if (textArea) {
      if (event?.trim()) {
        textArea.style.height = `${textArea.scrollHeight}px`;
      } else {
        textArea.style.height = "32.4px";
      }
    }
  }
  createForm() {
    this.formGroup = this.formBuilder.group({
      text: ["", [RxwebValidators.required(), noWhitespaceValidator]],
    });
  }
  notify(result) {
    if (result) {
      this.toastrService.show("Train successfully", `Notification`, {
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
        status: "success",
      });
    } else {
      this.toastrService.show("Train unsuccessfully", `Notification`, {
        position: NbGlobalPhysicalPosition.BOTTOM_LEFT,
        status: "danger",
      });
    }
  }
  ngOnInit() {
    this.grammarStatusChangedSubscription =
      this.signalRService.statusGrammarChanged.subscribe((rs) => {
        this.notify(rs);
        this.multipleGrammar.getGrammarData();
      });
    for (let [key, value] of Object.entries(this.data)) {
      this.data[key] = this.cell.getAttribute(key);
    }

    if (this.data.grammarArray) {
      this.grammarArray = JSON.parse(this.data.grammarArray);
    }

    if (this.data.attribute?.trim() == "" || !this.data.attribute) {
      this.data.attribute = null;
    }

    this.windowRef.onClose.subscribe(() => this.submit());
  }
  handleSaveAction() {
    this.windowRef.close();
  }
  handleCancelAction() {
    this.cancelAction = true;
    this.windowRef.close(true);
  }
  getAttribute(event) {
    this.data.attribute = event;
  }
  getEntityAttribute(event) {
    this.data.entityAttribute = event;
  }
  submit() {
    if (!this.cancelAction) {
      this.data.grammarArray = JSON.stringify(this.grammarArray);
      for (let [key, value] of Object.entries(this.data)) {
        if (typeof this.data[key] == "string") {
          value = value?.trim();
        }
        this.cell.setAttribute(key, value || "");
      }
      const checkAttributeCell = this.graph
        .getModel()
        .getCell(this.cell.getId());
      const fieldsRequired = [this.data.text?.trim()];
      const check = this.graphService.checkIsRequired(
        this.graph,
        fieldsRequired,
        checkAttributeCell
      );
      this.cell.setAttribute("checkFields", check?.toString());
    }
  }

  selectVariable(value) {
    if (value?.default == "VARIABLE") {
      this.dialogService
        .open(DialogAttributeComponent, { autoFocus: false })
        .onClose.subscribe((rs) => {
          if (rs) {
            this.filteredOptions$ = this.filteredOptions$.pipe(
              map((options) => [...options])
            );
            this.selectComponents.writeValue(rs);
            this.data.attribute = rs;
          }
        });
    }
  }
  getVariable($event) {
    this.data.attribute = $event;
  }
}
